import React, { Suspense, useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import AppContext from "./app-context";
import Dialog from "./components/common/dialog";
import route from "./router";
import { setToken } from "./utils";
import { getUser } from "./data";
import { useServiceEffect } from "./hook";
import Head from "./components/common/head";
import Foot from "./components/common/foot";
import Tool from "./components/common/tool";
import "./fonts/style.css";
import "./app.css";
import "./images/favicon.ico";

// const fallback = () => (<div>Loading...</div>)

export default function App() {
  function login(data = {}) {
    setCtx({
      ...ctx,
      isLogin: true,
      loadedAuth: true,
      user: { name: data.name || "", phone: data.phone || "" },
    });
  }
  const [ctx, setCtx] = useState({
    user: { name: "", phone: "" },
    isLogin: false,
    loadedAuth: false,
    showAuthDialog: false,
    globalMsg: "",
    login,
    logout: () => {
      setToken("");
      setCtx({
        ...ctx,
        user: { name: "", phone: "" },
        isLogin: false,
        loadedAuth: true,
      });
    },
    openAuthDialog: (msg) => {
      setCtx({
        ...ctx,
        showAuthDialog: true,
        loadedAuth: true,
        globalMsg: msg || "请先登录",
      });
    },
    closeAuthDialog: () => {
      setCtx({
        ...ctx,
        showAuthDialog: false,
        loadedAuth: true,
        globalMsg: "",
      });
    },
  });

  useServiceEffect(
    getUser,
    { run: 1 },
    {
      success: (res = {}) => {
        if (res && res.recode === 200 && res.user) {
          const name =
            res.user.linkman ||
            res.user.customName ||
            res.user.username ||
            res.user.code;
          const phone = res.user.phone || res.user.realPhone;

          ctx.login({ name, phone });
        }
      },
      fail: () => {
        ctx.logout();
      },
    }
  );

  // const path = window.location.pathname;
  // const [show, setShow] = useState(true);

  // useEffect(() => {
  //   if (/\/data\/*/.test(path)) {
  //     setShow(false);
  //   }
  // }, [path]);

  return (
    <>
      <AppContext.Provider value={ctx}>
        <Router>
          <Head></Head>
          <Switch>
            <Suspense fallback={null}>
              {route.map((item) => (
                <Route
                  key={item.path}
                  exact
                  path={item.path}
                  component={item.component}
                />
              ))}
            </Suspense>
          </Switch>
          {true && (
            <>
              <Foot></Foot>
              <Tool></Tool>
            </>
          )}
        </Router>
      </AppContext.Provider>
      <Dialog
        className="auth-dialog"
        show={ctx.showAuthDialog}
        okText=""
        cancelText=""
        title="温馨提示"
        onClose={ctx.closeAuthDialog}
      >
        <p>{ctx.globalMsg}</p>
      </Dialog>
    </>
  );
}
